module.exports = __webpack_public_path__ + "static/media/forest-mobile.7dd93b5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forest-mobile.mp4
// module id = dNdw
// module chunks = 1